const config = {
  rowSelection: false,
  listTitle: '谈单内容配置',
  searchMode: "group",
  // tableType: "antd",
  columns: [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 180,
      ellipsis: true
    },
    {
      title: '排序',
      dataIndex: 'sortNumber',
      width: 80,
      ellipsis: true
    },
    {
      title: '适用门店',
      dataIndex: 'companyList',
      render: 'companyListFn',
      width: 160,
      ellipsis: true
    },
    {
      title: '一级菜单编码',
      dataIndex: 'code',
      width: 120,
      ellipsis: true
    },
    {
      title: '一级菜单名称',
      dataIndex: 'name',
      width: 150,
      ellipsis: true
    },
    {
      title: '谈单时适用角色',
      dataIndex: 'roleNames',
      render: 'roleList',
      width: 150,
      ellipsis: true
    },
    {
      title: '是否启用',
      dataIndex: 'status',
      render: "statusFn",
      width: 120
    },
    {
      title: '更新人',
      dataIndex: 'modifiedByName',
      width: 110,
      ellipsis: true
    },
    {
      title: '更新时间',
      dataIndex: 'lastUpdatedTime',
      itemType: "dateTime",
      width: 150,
      ellipsis: true
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 230,
      render: 'operationFn',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: "companyId",
      label: "门店",
      itemType: "select",
      key: "id",
      labelKey: "name",
      data: "companyList",
      allowClear: true
    },
    {
      name: "name",
      label: "一级菜单名称",
      labelProps: {
        width: 90
      }
    },
  ],
  searchFormConfig: false,
  footer: [
    {
      label: "新增",
      type: "primary",
      events: ["onClick:onAdd"]
    }
  ]
}

export default config
